import { render, staticRenderFns } from "./how-it-works.vue?vue&type=template&id=5cbc661f&"
import script from "./how-it-works.vue?vue&type=script&lang=js&"
export * from "./how-it-works.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports